import React, { FunctionComponent, useState } from "react";
import { Aside, ButtonProps, CommandBarButton } from "sprint-common-web";

import { CreateFramerateProfileForm } from "../forms/create/CreateFramerateProfileForm";

export type AddFramerateProfileButtonProps = ButtonProps;

export const AddFramerateProfileButton: FunctionComponent<AddFramerateProfileButtonProps> = (
    props: AddFramerateProfileButtonProps
) => {
    const { disabled } = props;

    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const closeAside = () => {
        setIsAsideOpen(false);
    };

    const openAside = () => {
        setIsAsideOpen(true);
    };

    const handleFormSubmit = () => {
        closeAside();
    };

    return (
        <>
            <CommandBarButton onClick={openAside} text="Add" icon="Add" disabled={disabled} />
            <Aside isOpen={isAsideOpen} type="form" headerText={"Add Framerate Profile"} onDismiss={closeAside}>
                <CreateFramerateProfileForm onCancel={closeAside} onSubmit={handleFormSubmit} />
            </Aside>
        </>
    );
};
